import { SyntheticEvent } from 'react';

export enum ComponentSize {
  base = 'base',
  sm = 'sm',
}

export type MetricWeight = 'g';
export type ImperialWeight = 'lb' | 'oz';

export type EventHandlerProps = {
  onClick?: (event: SyntheticEvent) => void;
  onKeyUp?: (event: SyntheticEvent) => void;
  onKeyDown?: (event: SyntheticEvent) => void;
  onKeyPress?: (event: SyntheticEvent) => void;
  onMouseEnter?: (event: SyntheticEvent) => void;
  onMouseLeave?: (event: SyntheticEvent) => void;
  onChange?: (event: SyntheticEvent) => void;
  onBlur?: (event: SyntheticEvent) => void;
  onFocus?: (event: SyntheticEvent) => void;
};
